import React from "react";
import { caseStudies } from "../data/mock";
import { Reveal, ChapterTag } from "../lib/motion";

const stages = [
  { key: "situation", label: "Situation" },
  { key: "found", label: "What I found" },
  { key: "changed", label: "What changed" },
  { key: "result", label: "Result" },
];

export const CaseStudies = () => {
  return (
    <section id="results" data-testid="casestudies-section" className="py-24 sm:py-32 bg-[#FAF7F2]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <ChapterTag num="08" label="Results" />
          <h2 className="mt-6 font-display font-semibold text-stone-900 tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {caseStudies.heading}
          </h2>
          <p className="mt-4 text-stone-500 font-display  text-base md:text-lg">{caseStudies.intro}</p>
        </Reveal>

        <div className="mt-14 space-y-8">
          {caseStudies.items.map((cs, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className="rounded-3xl bg-white border border-stone-200 p-8 sm:p-10 hover:shadow-[0_16px_40px_rgba(3,46,45,0.06)] transition-shadow duration-400"
              data-testid={`casestudy-card-${i}`}
            >
              <div className="flex flex-wrap items-baseline justify-between gap-3 mb-8">
                <h3 className="font-display font-semibold text-xl sm:text-2xl text-stone-900 leading-tight max-w-xl">
                  {cs.title}
                </h3>
                <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#A86532] bg-[#A86532]/10 px-3 py-1.5 rounded-full">
                  {cs.sector}
                </span>
              </div>
              <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {stages.map((stage, j) => (
                  <div key={stage.key} className={`relative pl-5 ${j === 3 ? "" : ""}`}>
                    <span className={`absolute left-0 top-1 bottom-1 w-[2px] rounded ${j === 3 ? "bg-brand-500" : "bg-stone-200"}`} />
                    <p className={`text-[11px] font-semibold uppercase tracking-[0.18em] mb-2 ${j === 3 ? "text-brand-700" : "text-stone-400"}`}>
                      {stage.label}
                    </p>
                    <p className={`text-sm leading-relaxed ${j === 3 ? "text-stone-900 font-medium" : "text-stone-600"}`}>
                      {cs[stage.key]}
                    </p>
                  </div>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
